import { render, staticRenderFns } from "./MdtListDisease.vue?vue&type=template&id=6c115260&scoped=true"
import script from "./MdtListDisease.vue?vue&type=script&lang=js"
export * from "./MdtListDisease.vue?vue&type=script&lang=js"
import style0 from "./MdtListDisease.vue?vue&type=style&index=0&id=6c115260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c115260",
  null
  
)

export default component.exports